<section
  class="relative py-24 overflow-hidden bg-bg-base border-t border-border-subtle"
>
  <!-- Background Pattern -->
  <div class="absolute inset-0 opacity-[0.03]">
    <div
      class="absolute inset-0"
      style="
        background-image: radial-gradient(circle at 2px 2px, white 1px, transparent 0);
        background-size: 40px 40px;
      "
    ></div>
  </div>

  <!-- Premium Blur Orbs -->
  <div class="absolute inset-0 opacity-20 pointer-events-none">
    <div class="absolute top-20 left-20 w-96 h-96 bg-primary-soft rounded-full blur-[120px]"></div>
    <div class="absolute bottom-20 right-20 w-96 h-96 bg-primary-deep rounded-full blur-[120px]"></div>
  </div>

  <div class="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
    <!-- Section Header -->
    <div class="text-center mb-16">
      <div
        class="inline-flex items-center gap-2 px-4 py-2 border border-primary/20 bg-primary-soft/30 backdrop-blur-md shadow-subtle rounded-full mb-6"
      >
        <i class="fa-solid fa-headset text-primary"></i>
        <span class="text-sm font-medium text-text-primary">{{ 'contactUs.followUs' | translate }}</span>
      </div>
      <h2 class="h2 text-text-primary mb-4">
        {{ 'contactUs.title' | translate }}
      </h2>
      <p class="body-large text-text-secondary max-w-2xl mx-auto">
        {{ 'contactUs.subtitle' | translate }}
      </p>
    </div>

    <!-- Contact Cards Grid -->
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
      <!-- Address Card -->
      <div
        class="surface-elevated group rounded-2xl p-6 border border-border hover:border-primary/50 transition-all duration-300 hover:shadow-primary-glow hover:-translate-y-1 relative overflow-hidden"
      >
        <div
          class="absolute inset-0 bg-gradient-to-br from-primary-soft/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"
        ></div>
        <div class="relative z-10">
          <div
            class="w-14 h-14 bg-primary-soft/20 border border-primary/30 rounded-xl flex items-center justify-center mb-4 shadow-subtle group-hover:shadow-primary-glow transition-all duration-300"
          >
            <i class="fa-solid fa-location-dot text-primary text-2xl"></i>
          </div>
          <h3 class="h3 text-text-primary mb-2">
            {{ 'contactUs.address.title' | translate }}
          </h3>
          <p class="body-medium text-text-secondary">
            {{ 'contactUs.address.value' | translate }}
          </p>
        </div>
      </div>

      <!-- Phone Card -->
      <div
        class="surface-elevated group rounded-2xl p-6 border border-border hover:border-primary/50 transition-all duration-300 hover:shadow-primary-glow hover:-translate-y-1 relative overflow-hidden"
      >
        <div
          class="absolute inset-0 bg-gradient-to-br from-primary-soft/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"
        ></div>
        <div class="relative z-10">
          <div
            class="w-14 h-14 bg-primary-soft/20 border border-primary/30 rounded-xl flex items-center justify-center mb-4 shadow-subtle group-hover:shadow-primary-glow transition-all duration-300"
          >
            <i class="fa-solid fa-phone text-primary text-2xl"></i>
          </div>
          <h3 class="h3 text-text-primary mb-2">
            {{ 'contactUs.phone.title' | translate }}
          </h3>
          <a
            href="tel:+201234567890"
            class="body-medium text-text-secondary hover:text-primary transition-colors"
          >
            {{ 'contactUs.phone.value' | translate }}
          </a>
        </div>
      </div>

      <!-- Email Card -->
      <div
        class="surface-elevated group rounded-2xl p-6 border border-border hover:border-primary/50 transition-all duration-300 hover:shadow-primary-glow hover:-translate-y-1 relative overflow-hidden"
      >
        <div
          class="absolute inset-0 bg-gradient-to-br from-primary-soft/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"
        ></div>
        <div class="relative z-10">
          <div
            class="w-14 h-14 bg-primary-soft/20 border border-primary/30 rounded-xl flex items-center justify-center mb-4 shadow-subtle group-hover:shadow-primary-glow transition-all duration-300"
          >
            <i class="fa-solid fa-envelope text-primary text-2xl"></i>
          </div>
          <h3 class="h3 text-text-primary mb-2">
            {{ 'contactUs.email.title' | translate }}
          </h3>
          <a
            href="mailto:info@HomiGo.com"
            class="body-medium text-text-secondary hover:text-primary transition-colors break-all"
          >
            {{ 'contactUs.email.value' | translate }}
          </a>
        </div>
      </div>

      <!-- Working Hours Card -->
      <div
        class="surface-elevated group rounded-2xl p-6 border border-border hover:border-primary/50 transition-all duration-300 hover:shadow-primary-glow hover:-translate-y-1 relative overflow-hidden"
      >
        <div
          class="absolute inset-0 bg-gradient-to-br from-primary-soft/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"
        ></div>
        <div class="relative z-10">
          <div
            class="w-14 h-14 bg-primary-soft/20 border border-primary/30 rounded-xl flex items-center justify-center mb-4 shadow-subtle group-hover:shadow-primary-glow transition-all duration-300"
          >
            <i class="fa-solid fa-clock text-primary text-2xl"></i>
          </div>
          <h3 class="h3 text-text-primary mb-3">
            {{ 'contactUs.workingHours.title' | translate }}
          </h3>
          <div class="space-y-2 body-medium">
            <div>
              <p class="text-text-muted">{{ 'contactUs.workingHours.weekdays' | translate }}</p>
              <p class="text-text-secondary font-medium">
                {{ 'contactUs.workingHours.weekdaysTime' | translate }}
              </p>
            </div>
            <div class="pt-2 border-t border-border-subtle">
              <p class="text-text-muted">{{ 'contactUs.workingHours.weekend' | translate }}</p>
              <p class="text-danger font-medium">
                {{ 'contactUs.workingHours.weekendTime' | translate }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Social Media Section -->
    <div
      class="surface-card relative rounded-3xl p-8 border border-border hover:border-primary/30 transition-all duration-300"
    >
      <div class="text-center mb-6">
        <h3 class="h3 text-text-primary mb-2">{{ 'contactUs.followUs' | translate }}</h3>
        <p class="body-medium text-text-secondary">{{ 'contactUs.socialMediaSubtitle' | translate }}</p>
      </div>

      <div class="flex flex-wrap justify-center gap-4">
        <a
          href="#"
          class="group relative w-14 h-14 surface-elevated border border-border backdrop-blur-sm rounded-xl flex items-center justify-center hover:bg-gradient-to-br hover:from-[#1877F2] hover:to-[#0C63D4] hover:border-transparent transition-all duration-300 hover:scale-110 hover:shadow-[0_8px_20px_rgba(24,119,242,0.4)]"
        >
          <i
            class="fa-brands fa-facebook text-text-secondary group-hover:text-white text-2xl group-hover:scale-110 transition-all"
          ></i>
        </a>

        <a
          href="#"
          class="group relative w-14 h-14 surface-elevated border border-border backdrop-blur-sm rounded-xl flex items-center justify-center hover:bg-gradient-to-br hover:from-[#E4405F] hover:to-[#C13584] hover:border-transparent transition-all duration-300 hover:scale-110 hover:shadow-[0_8px_20px_rgba(228,64,95,0.4)]"
        >
          <i
            class="fa-brands fa-instagram text-text-secondary group-hover:text-white text-2xl group-hover:scale-110 transition-all"
          ></i>
        </a>

        <a
          href="#"
          class="group relative w-14 h-14 surface-elevated border border-border backdrop-blur-sm rounded-xl flex items-center justify-center hover:bg-gradient-to-br hover:from-[#1DA1F2] hover:to-[#0C85D0] hover:border-transparent transition-all duration-300 hover:scale-110 hover:shadow-[0_8px_20px_rgba(29,161,242,0.4)]"
        >
          <i
            class="fa-brands fa-x-twitter text-text-secondary group-hover:text-white text-2xl group-hover:scale-110 transition-all"
          ></i>
        </a>

        <a
          href="#"
          class="group relative w-14 h-14 surface-elevated border border-border backdrop-blur-sm rounded-xl flex items-center justify-center hover:bg-gradient-to-br hover:from-[#0A66C2] hover:to-[#004182] hover:border-transparent transition-all duration-300 hover:scale-110 hover:shadow-[0_8px_20px_rgba(10,102,194,0.4)]"
        >
          <i
            class="fa-brands fa-linkedin text-text-secondary group-hover:text-white text-2xl group-hover:scale-110 transition-all"
          ></i>
        </a>

        <a
          href="#"
          class="group relative w-14 h-14 surface-elevated border border-border backdrop-blur-sm rounded-xl flex items-center justify-center hover:bg-gradient-to-br hover:from-[#25D366] hover:to-[#128C7E] hover:border-transparent transition-all duration-300 hover:scale-110 hover:shadow-[0_8px_20px_rgba(37,211,102,0.4)]"
        >
          <i
            class="fa-brands fa-whatsapp text-text-secondary group-hover:text-white text-2xl group-hover:scale-110 transition-all"
          ></i>
        </a>

        <a
          href="#"
          class="group relative w-14 h-14 surface-elevated border border-border backdrop-blur-sm rounded-xl flex items-center justify-center hover:bg-gradient-to-br hover:from-[#FF0000] hover:to-[#CC0000] hover:border-transparent transition-all duration-300 hover:scale-110 hover:shadow-[0_8px_20px_rgba(255,0,0,0.4)]"
        >
          <i
            class="fa-brands fa-youtube text-text-secondary group-hover:text-white text-2xl group-hover:scale-110 transition-all"
          ></i>
        </a>
      </div>
    </div>
  </div>
</section>
